import { render, staticRenderFns } from "./ScoreScreenBridge.vue?vue&type=template&id=b7c69a8e&scoped=true&"
import script from "./ScoreScreenBridge.vue?vue&type=script&lang=js&"
export * from "./ScoreScreenBridge.vue?vue&type=script&lang=js&"
import style0 from "./ScoreScreenBridge.vue?vue&type=style&index=0&id=b7c69a8e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c69a8e",
  null
  
)

export default component.exports